import { combineReducers } from "redux";
import app from "../containers/App/store/reducer";
import stateToken from "../config/msal/TokenReducer";
import businessPartner from "../containers/BusinessPartnerDetails/store/reducer";
import rejectedBusinessPartner from "../containers/RejectedBusinessPartners/store/reducer";
import businessPartnerList from "../containers/BusinessPartnerLists/store/reducer";
import notification from "../containers/Notification/store/reducer";
import changeLog from "../containers/ChangeLog/store/reducer";
import stewardBusinessPartnerLists from "../containers/StewardBusinessPartnerLists/store/reducer";

import err from "../containers/Common/ErrorHandler/reducer";
import { AppState } from "../containers/App/types";
import { ErrState } from "../containers/Common/ErrorHandler/types";

export interface GlobalState {
  app: AppState;
  err: ErrState;
}
export const rootReducer = combineReducers({
  app,
  stateToken,
  err,
  businessPartner,
  rejectedBusinessPartner,
  businessPartnerList,
  notification,
  changeLog,
  stewardBusinessPartnerLists
});
export type RootState = ReturnType<typeof rootReducer>;
